module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page",
    attrs: {
      "id": "page-soorten"
    }
  }, [_c('div', {
    staticClass: "page__content container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12-sm"
  }, [_c('h1', [_vm._v("Hybride docenten zijn er in allerlei soorten en maten")]), _vm._v(" "), _c('p', [_vm._v("Dé hybride docent bestaat niet; er zijn talloze combinaties mogelijk. Zie hieronder enkele voorbeelden.")]), _vm._v(" "), _c('div', {
    staticClass: "page-soorten__numerator"
  }, _vm._l((4), function(index) {
    return _c('div', {
      staticClass: "page-soorten__numerator-item",
      class: {
        'page-soorten__numerator-item--active': index === _vm.selectedTypeIndex
      },
      on: {
        "click": function($event) {
          _vm.selectType(index)
        }
      }
    }, [_vm._v(_vm._s(index))])
  })), _vm._v(" "), _c('ul', {
    staticClass: "page-soorten__type-description"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.omgeving2))]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.rol2))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5-sm"
  }, [_c('p', [_vm._v("Baan 1")]), _vm._v(" "), _c('div', {
    staticClass: "job-combination job-combination--baan1"
  }, [_c('img', {
    staticClass: "job-combination__building",
    class: _vm.firstBaanClass,
    attrs: {
      "src": require("../../assets/images/school90h.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "job-combination__person",
    class: _vm.firstBaanClass,
    attrs: {
      "src": require("../../assets/images/docent-vrouw-100.png")
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-5-sm"
  }, [_c('p', [_vm._v("Baan 2")]), _vm._v(" "), _c('div', {
    staticClass: "job-combination"
  }, [_c('img', {
    staticClass: "job-combination__building",
    class: _vm.schoolClass,
    attrs: {
      "src": require("../../assets/images/school90h.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "job-combination__building",
    class: _vm.bedrijfClass,
    attrs: {
      "src": require("../../assets/images/bedrijf90h.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "job-combination__person",
    class: _vm.docentClass,
    attrs: {
      "src": require("../../assets/images/docent-vrouw-100.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "job-combination__person",
    class: _vm.notDocentClass,
    attrs: {
      "src": require("../../assets/images/niet-docent-vrouw-100.png")
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "page-soorten__praktijk-header"
  }, [_vm._v("In de praktijk:")]), _vm._v(" "), _c('div', {
    staticClass: "row page-soorten__praktijk"
  }, [_c('div', {
    staticClass: "col-12-sm"
  }, [_c('p', {
    staticClass: "page-soorten__praktijk-text"
  }, [_vm._v(_vm._s(_vm.exampleText))]), _vm._v(" "), _c('div', [(_vm.selectedTypeIndex === 1) ? _c('quote', {
    attrs: {
      "quote": _vm.types[1].quote,
      "img-url": _vm.types[1].imgUrl
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTypeIndex === 2) ? _c('quote', {
    attrs: {
      "quote": _vm.types[2].quote,
      "img-url": _vm.types[2].imgUrl
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTypeIndex === 3) ? _c('quote', {
    attrs: {
      "quote": _vm.types[3].quote,
      "img-url": _vm.types[3].imgUrl
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTypeIndex === 4) ? _c('quote', {
    attrs: {
      "quote": _vm.types[4].quote,
      "img-url": _vm.types[4].imgUrl
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('page-next-button', {
    on: {
      "click": _vm.nextHandler
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-2-sm"
  }, [_c('img', {
    staticClass: "page-soorten__plus",
    attrs: {
      "src": require("../../assets/icons/plus.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-789b94c8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-soorten.vue
// module id = 151
// module chunks = 0